import { render } from "./Base64ConverterPage.vue?vue&type=template&id=0c66d5c4&scoped=true"
import script from "./Base64ConverterPage.vue?vue&type=script&lang=js"
export * from "./Base64ConverterPage.vue?vue&type=script&lang=js"

import "./Base64ConverterPage.vue?vue&type=style&index=0&id=0c66d5c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c66d5c4"]])

export default __exports__